import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";

export const ColumnsTicketDay = [
  {
    prop: "Fecha",
    label: "Fecha",
    sortable: true,
    formatter: DatetimeFormatter
  },
  {
    prop: "Cantidad",
    label: "Cantidad",
    sortable: true
  }
];
